module.exports = __webpack_public_path__ + "6ec4f5c98bb3b4d9e38b6e8243a96f7b.svg";